"use client";

import { openModal } from "@decibeltrade/web-core/modal";
import { createElement } from "react";

const MODAL_ID = "language-switcher-modal";

/** Opens the language switcher; loads modal UI on first use to keep nav/footer bundles small. */
export function openLanguageSwitcherModal(): void {
  void import("./language-switcher-modal").then((mod) => {
    openModal({
      id: MODAL_ID,
      renderContent: (modalProps) => createElement(mod.LanguageSwitcherModal, modalProps),
    });
  });
}
